import { OGProperties, PageTags } from '../types';
import { RoutesPaths } from '@router/constants';

const title = 'User Agreement'
const url = window.location.origin + RoutesPaths.USER_AGREEMENT

export const userAgreement: PageTags = {
  title: `| ${title}`,
  url: url,
  properties: [
    {
      property: OGProperties.title,
      content: `FireStarter | ${title}`,
    },
    {
      property: OGProperties.description,
      content: 'Terms of service between individual user and FireStarter Finance Inc.',
    },
    {
      property: OGProperties.url,
      content: url,
    },
  ]
}
